export class QueueItem {
    public progress = 0;
    public completed = false;
    public success = false;
    public message: string;
    public error = false;
    public loading = false;

    constructor(
        public file: Blob,
        public name: string,
    ) {}

    setError(message: string) {
        this.loading = false;
        this.completed = true;
        this.success = false;
        this.error = true;
        this.progress = 100;
        this.message = message;
    }

    setProgress(progress: number) {
        this.loading = true;
        this.completed = false;
        this.success = false;
        this.error = false;
        this.progress = progress;
        this.message = '';
    }

    setComplete() {
        this.loading = false;
        this.completed = true;
        this.success = true;
        this.error = false;
        this.progress = 100;
        this.message = '';
    }
}
